import { closestHTMLElement } from "../../lib/dom.js";

export async function handleLogsClick(target, deps) {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  const logWorkoutShareBtn = closestHTMLElement(target, ".open-log-workout-share-btn");
  if (logWorkoutShareBtn) {
    await deps.handleOpenLogWorkoutShare(logWorkoutShareBtn.dataset.workoutId);
    return true;
  }

  const fullSessionButton = closestHTMLElement(target, "[data-role='logs-open-full-session']");
  if (fullSessionButton) {
    await deps.handleOpenLogsFullSession(
      fullSessionButton.dataset.workoutId,
      fullSessionButton.dataset.date,
    );
    return true;
  }

  const logToggleButton = closestHTMLElement(target, "[data-role='toggle-workout-log']");
  if (logToggleButton) {
    await deps.handleToggleWorkoutLog(
      logToggleButton.dataset.workoutId,
      String(logToggleButton.dataset.logContext || "date"),
    );
    return true;
  }

  const logsModeButton = closestHTMLElement(target, "[data-role='logs-set-mode']");
  if (logsModeButton) {
    deps.handleSetLogsMode(logsModeButton.dataset.mode);
    return true;
  }

  const logsCalendarNavButton = closestHTMLElement(target, "[data-role='logs-calendar-nav']");
  if (logsCalendarNavButton) {
    deps.handleShiftLogsCalendarMonth(Number(logsCalendarNavButton.dataset.delta || 0));
    return true;
  }

  const logsDateButton = closestHTMLElement(target, "[data-role='logs-select-date']");
  if (logsDateButton) {
    deps.handleSelectLogsDate(logsDateButton.dataset.date);
    return true;
  }

  if (closestHTMLElement(target, "#openLogsExerciseSearchModalBtn")) {
    deps.openLogsExerciseSearchModal();
    return true;
  }

  return false;
}
